import React from "react";
import AllPostFilter from "./AllPostFilter";
import RecentPosts from "./RecentPosts";

export default function AllPosts({ data, activeTab }) {
  return (
    <div>
      <div className="row">
        <div className="col-lg-3 col-md-4">
          <AllPostFilter data={data} />
        </div>
        <div className="col-lg-9 col-md-8 filter-right">
          <h2>Posts</h2>
          <RecentPosts data={data} activeTab={activeTab} />
        </div>
      </div>
    </div>
  );
}
